import { resolveMarketingUrl } from "./marketing-url";
import { currentQaEnvironment } from "./qa-build-environment";

/**
 * Base URL of the standalone marketing site (landing, pricing, help, legal…).
 * Those pages were moved out of this app, so anything here that points at them
 * (the bare `/` for anonymous visitors, in-app Help / Terms links) links out.
 *
 * Env-driven per environment (build-time inlined by Vite):
 *   - preview: https://ezx-marketing-preview.trypreview.app
 *   - prod:    https://ezx-marketing-prod.trypreview.app until cutover
 */
export const MARKETING_URL = resolveMarketingUrl(
  import.meta.env.VITE_MARKETING_URL,
  import.meta.env.VITE_AUTH0_CALLBACK_URL,
  import.meta.env.DEV,
  currentQaEnvironment()
);

export const marketingUrl = (path = "") =>
  `${MARKETING_URL}${path.startsWith("/") ? path : path && `/${path}`}`;
